import clsx from 'clsx'
import { Col, Icon, Row } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import styles from 'modules/Finance/Wallets/subcomponents/HistoryList/HistoryList.module.scss'
import Money from '../../../Money'
import { useTranslation } from 'react-i18next'

const TransactionRow = ({
  amount,
  type = null,
  currency = null,
  document: {
    status = null,
    id = null,
    account = null,
    type: documentType,
    invoice_number = null,
  } = {},
}) => {
  const { t } = useTranslation(['wallets'])

  const heading = useMemo(
    () =>
      `${
        type
          ? t(`transaction.${type}.${amount > 0 ? 'in' : 'out'}`, {
              accountLogin: account?.login ?? '',
              accountType: t(`common::accountType.${account?.type ?? ''}`),
              documentType: documentType ? t(`common::documentType.${documentType}`) : '',
              id,
            })
          : ''
      }${
        !['ad_tax_hold_withdrawal', 'ad_tax_hold_deposit'].includes(type) && invoice_number
          ? ` № ${invoice_number}`
          : ''
      }.`,
    [type, amount, account, documentType, t],
  )

  const action = useMemo(
    () =>
      `${type ? t(`transaction.operation`) : ''} ${id || ''} ${
        status ? t(`transaction.status.${status}`) : ''
      }`,
    [type, id, status, t],
  )

  const breakpoints = useBreakpoint()

  const isPositive = amount >= 0
  const direction = isPositive ? 'up' : 'down'
  const color = isPositive ? 'Label-Confirm' : 'Label-Error-Secondary'

  return (
    <Row className={styles['history-list__row']}>
      <Col
        s="auto"
        sm="auto"
        xs="auto"
        className={styles['history-list__col']}
      >
        <div
          className={clsx(
            styles['history-list__badge'],
            styles['history-list__badge_' + direction],
          )}
        >
          <Icon
            width={!breakpoints.md ? 16 : 11}
            name="arrow-rounded"
            color={color}
          />
        </div>
      </Col>
      <Col
        className={styles['history-list__col']}
        fluid
      >
        <div
          className={styles['history-list__heading']}
          title={heading}
        >
          {heading}
        </div>
        <div className={styles['history-list__action']}>{action}</div>
      </Col>
      <Col
        s="4"
        xs="4"
        className={styles['history-list__col']}
      >
        <div
          className={clsx(styles['history-list__cost'], styles['history-list__cost_' + direction])}
        >
          <Money
            number={amount}
            currency={currency}
          />
        </div>
      </Col>
    </Row>
  )
}

export default TransactionRow

TransactionRow.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
  action: PropTypes.string,
  heading: PropTypes.string,
  status: PropTypes.oneOf(['pending', 'success', 'declined', 'cancelled', 'error']),
  type: PropTypes.string,
  created_at: PropTypes.string,
  document: PropTypes.shape({
    status: PropTypes.string,
    id: PropTypes.number,
    account: PropTypes.shape({
      login: PropTypes.string,
      type: PropTypes.string,
    }),
    type: PropTypes.string,
  }),
}
